/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createClassifiedDocument = /* GraphQL */ `
  mutation CreateClassifiedDocument($input: CreateClassifiedDocumentInput!) {
    createClassifiedDocument(input: $input) {
      category
      complianceType
      confidence
      createdAt
      fileName
      id
      projectBuildingDataIds
      projectId
      requirementId
      storageLinkId
      updatedAt
      __typename
    }
  }
`;
export const createCommunicationLink = /* GraphQL */ `
  mutation CreateCommunicationLink(
    $condition: ModelCommunicationLinkConditionInput
    $input: CreateCommunicationLinkInput!
  ) {
    createCommunicationLink(condition: $condition, input: $input) {
      createdAt
      id
      name
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      type
      updatedAt
      url
      __typename
    }
  }
`;
export const createCompany = /* GraphQL */ `
  mutation CreateCompany($input: CreateCompanyInput!) {
    createCompany(input: $input) {
      billingCycle
      createdAt
      createdByUserId
      domain
      id
      members {
        items {
          company {
            billingCycle
            createdAt
            createdByUserId
            domain
            id
            members {
              nextToken
              __typename
            }
            name
            planKey
            planPriceId
            resources {
              nextToken
              __typename
            }
            seatLimit
            stripeCustomerId
            stripeSubscriptionId
            subscriptionStatus
            updatedAt
            __typename
          }
          companyId
          createdAt
          email
          id
          role
          status
          updatedAt
          userId
          __typename
        }
        nextToken
        __typename
      }
      name
      planKey
      planPriceId
      resources {
        items {
          company {
            billingCycle
            createdAt
            createdByUserId
            domain
            id
            members {
              nextToken
              __typename
            }
            name
            planKey
            planPriceId
            resources {
              nextToken
              __typename
            }
            seatLimit
            stripeCustomerId
            stripeSubscriptionId
            subscriptionStatus
            updatedAt
            __typename
          }
          companyId
          createdAt
          createdByUserId
          description
          id
          name
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      seatLimit
      stripeCustomerId
      stripeSubscriptionId
      subscriptionStatus
      updatedAt
      __typename
    }
  }
`;
export const createCompanyMember = /* GraphQL */ `
  mutation CreateCompanyMember($input: CreateCompanyMemberInput!) {
    createCompanyMember(input: $input) {
      company {
        billingCycle
        createdAt
        createdByUserId
        domain
        id
        members {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            email
            id
            role
            status
            updatedAt
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        planKey
        planPriceId
        resources {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            createdByUserId
            description
            id
            name
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        seatLimit
        stripeCustomerId
        stripeSubscriptionId
        subscriptionStatus
        updatedAt
        __typename
      }
      companyId
      createdAt
      email
      id
      role
      status
      updatedAt
      userId
      __typename
    }
  }
`;
export const createCompanyResource = /* GraphQL */ `
  mutation CreateCompanyResource(
    $condition: ModelCompanyResourceConditionInput
    $input: CreateCompanyResourceInput!
  ) {
    createCompanyResource(condition: $condition, input: $input) {
      company {
        billingCycle
        createdAt
        createdByUserId
        domain
        id
        members {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            email
            id
            role
            status
            updatedAt
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        planKey
        planPriceId
        resources {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            createdByUserId
            description
            id
            name
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        seatLimit
        stripeCustomerId
        stripeSubscriptionId
        subscriptionStatus
        updatedAt
        __typename
      }
      companyId
      createdAt
      createdByUserId
      description
      id
      name
      type
      updatedAt
      url
      __typename
    }
  }
`;
export const createComplianceCheck = /* GraphQL */ `
  mutation CreateComplianceCheck(
    $condition: ModelComplianceCheckConditionInput
    $input: CreateComplianceCheckInput!
  ) {
    createComplianceCheck(condition: $condition, input: $input) {
      createdAt
      estimatedCompletion
      id
      jobId
      processedDocuments
      projectId
      prompt
      selectedRequirementId
      status
      totalDocuments
      updatedAt
      userId
      __typename
    }
  }
`;
export const createComplianceIssue = /* GraphQL */ `
  mutation CreateComplianceIssue(
    $condition: ModelComplianceIssueConditionInput
    $input: CreateComplianceIssueInput!
  ) {
    createComplianceIssue(condition: $condition, input: $input) {
      aiAnalysis
      assignedTo
      categories
      checkId
      confidence
      createdAt
      deadline
      description
      expectedCompliance
      id
      identifiedIssue
      ncCode
      projectId
      references
      severity
      sourceDocuments
      status
      tags
      updatedAt
      __typename
    }
  }
`;
export const createParameter = /* GraphQL */ `
  mutation CreateParameter(
    $condition: ModelParameterConditionInput
    $input: CreateParameterInput!
  ) {
    createParameter(condition: $condition, input: $input) {
      createdAt
      id
      name
      operator
      requirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        storageLinkId
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        subRequirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        title
        updatedAt
        __typename
      }
      requirementId
      subRequirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        requirement {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          storageLinkId
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          subRequirements {
            items {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          title
          updatedAt
          __typename
        }
        requirementId
        title
        updatedAt
        __typename
      }
      subRequirementId
      type
      unit
      updatedAt
      value
      __typename
    }
  }
`;
export const createPersonalCompany = /* GraphQL */ `
  mutation CreatePersonalCompany($name: String!) {
    createPersonalCompany(name: $name) {
      company {
        billingCycle
        createdAt
        createdByUserId
        domain
        id
        members {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            email
            id
            role
            status
            updatedAt
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        planKey
        planPriceId
        resources {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            createdByUserId
            description
            id
            name
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        seatLimit
        stripeCustomerId
        stripeSubscriptionId
        subscriptionStatus
        updatedAt
        __typename
      }
      membership {
        company {
          billingCycle
          createdAt
          createdByUserId
          domain
          id
          members {
            items {
              companyId
              createdAt
              email
              id
              role
              status
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          planKey
          planPriceId
          resources {
            items {
              companyId
              createdAt
              createdByUserId
              description
              id
              name
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          seatLimit
          stripeCustomerId
          stripeSubscriptionId
          subscriptionStatus
          updatedAt
          __typename
        }
        companyId
        createdAt
        email
        id
        role
        status
        updatedAt
        userId
        __typename
      }
      __typename
    }
  }
`;
export const createProject = /* GraphQL */ `
  mutation CreateProject(
    $condition: ModelProjectConditionInput
    $input: CreateProjectInput!
  ) {
    createProject(condition: $condition, input: $input) {
      adjacentStreets
      averageGrade
      buildingClassification
      buildingFootprintArea
      buildingHeight
      buildingFootprintAreaExisting
      buildingFootprintAreaProposed
      grossFloorAreaExisting
      grossFloorAreaProposed
      communicationLinks {
        items {
          createdAt
          id
          name
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      companyId
      constructionType
      createdAt
      description
      entitiesData
      estimatedCompletion
      fireAlarm
      grossFloorArea
      hasBuildingCodeExtractions
      hazardousSubstances
      highBuilding
      id
      lastModified
      location
      majorOccupancy
      members {
        items {
          createdAt
          id
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          role
          updatedAt
          user {
            createdAt
            email
            id
            membershipId
            memberships {
              nextToken
              __typename
            }
            name
            updatedAt
            __typename
          }
          userId
          __typename
        }
        nextToken
        __typename
      }
      name
      occupancyCodes
      occupancyRegion
      occupancyTypes
      owner
      phase
      projectCategory
      requirements {
        items {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          storageLinkId
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          subRequirements {
            items {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          title
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      roughConstructionBudget
      settings {
        autoSave
        createdAt
        id
        notifications
        owner
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        theme
        updatedAt
        __typename
      }
      siteArea
      sprinklerSystem
      standpipe
      startDate
      status
      storageLinks {
        items {
          createdAt
          id
          name
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      storeysAboveGrade
      storeysBelowGrade
      team {
        createdAt
        id
        name
        projects {
          items {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      teamId
      type
      updatedAt
      zoningDesignation
      __typename
    }
  }
`;
export const createProjectMember = /* GraphQL */ `
  mutation CreateProjectMember(
    $condition: ModelProjectMemberConditionInput
    $input: CreateProjectMemberInput!
  ) {
    createProjectMember(condition: $condition, input: $input) {
      createdAt
      id
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      role
      updatedAt
      user {
        createdAt
        email
        id
        membershipId
        memberships {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        updatedAt
        __typename
      }
      userId
      __typename
    }
  }
`;
export const createProjectSettings = /* GraphQL */ `
  mutation CreateProjectSettings(
    $condition: ModelProjectSettingsConditionInput
    $input: CreateProjectSettingsInput!
  ) {
    createProjectSettings(condition: $condition, input: $input) {
      autoSave
      createdAt
      id
      notifications
      owner
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      theme
      updatedAt
      __typename
    }
  }
`;
export const createRequirement = /* GraphQL */ `
  mutation CreateRequirement(
    $condition: ModelRequirementConditionInput
    $input: CreateRequirementInput!
  ) {
    createRequirement(condition: $condition, input: $input) {
      createdAt
      description
      id
      parameters {
        items {
          createdAt
          id
          name
          operator
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          subRequirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          subRequirementId
          type
          unit
          updatedAt
          value
          __typename
        }
        nextToken
        __typename
      }
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      storageLinkId
      storageLinks {
        items {
          createdAt
          id
          name
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      subRequirements {
        items {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          title
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      title
      updatedAt
      __typename
    }
  }
`;
export const createStorageLink = /* GraphQL */ `
  mutation CreateStorageLink(
    $condition: ModelStorageLinkConditionInput
    $input: CreateStorageLinkInput!
  ) {
    createStorageLink(condition: $condition, input: $input) {
      createdAt
      id
      name
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      requirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        storageLinkId
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        subRequirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        title
        updatedAt
        __typename
      }
      requirementId
      type
      updatedAt
      url
      __typename
    }
  }
`;
export const createSubRequirement = /* GraphQL */ `
  mutation CreateSubRequirement(
    $condition: ModelSubRequirementConditionInput
    $input: CreateSubRequirementInput!
  ) {
    createSubRequirement(condition: $condition, input: $input) {
      createdAt
      description
      id
      parameters {
        items {
          createdAt
          id
          name
          operator
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          subRequirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          subRequirementId
          type
          unit
          updatedAt
          value
          __typename
        }
        nextToken
        __typename
      }
      requirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        storageLinkId
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        subRequirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        title
        updatedAt
        __typename
      }
      requirementId
      title
      updatedAt
      __typename
    }
  }
`;
export const createTeam = /* GraphQL */ `
  mutation CreateTeam(
    $condition: ModelTeamConditionInput
    $input: CreateTeamInput!
  ) {
    createTeam(condition: $condition, input: $input) {
      createdAt
      id
      name
      projects {
        items {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $condition: ModelUserConditionInput
    $input: CreateUserInput!
  ) {
    createUser(condition: $condition, input: $input) {
      createdAt
      email
      id
      membershipId
      memberships {
        items {
          createdAt
          id
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          role
          updatedAt
          user {
            createdAt
            email
            id
            membershipId
            memberships {
              nextToken
              __typename
            }
            name
            updatedAt
            __typename
          }
          userId
          __typename
        }
        nextToken
        __typename
      }
      name
      updatedAt
      __typename
    }
  }
`;
export const deleteClassifiedDocument = /* GraphQL */ `
  mutation DeleteClassifiedDocument($input: DeleteClassifiedDocumentInput!) {
    deleteClassifiedDocument(input: $input) {
      category
      complianceType
      confidence
      createdAt
      fileName
      id
      projectBuildingDataIds
      projectId
      requirementId
      storageLinkId
      updatedAt
      __typename
    }
  }
`;
export const updateClassifiedDocument = /* GraphQL */ `
  mutation UpdateClassifiedDocument($input: UpdateClassifiedDocumentInput!) {
    updateClassifiedDocument(input: $input) {
      category
      complianceType
      confidence
      createdAt
      fileName
      id
      projectBuildingDataIds
      projectId
      requirementId
      storageLinkId
      updatedAt
      __typename
    }
  }
`;
export const deleteCommunicationLink = /* GraphQL */ `
  mutation DeleteCommunicationLink(
    $condition: ModelCommunicationLinkConditionInput
    $input: DeleteCommunicationLinkInput!
  ) {
    deleteCommunicationLink(condition: $condition, input: $input) {
      createdAt
      id
      name
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      type
      updatedAt
      url
      __typename
    }
  }
`;
export const deleteCompany = /* GraphQL */ `
  mutation DeleteCompany($input: DeleteCompanyInput!) {
    deleteCompany(input: $input) {
      billingCycle
      createdAt
      createdByUserId
      domain
      id
      members {
        items {
          company {
            billingCycle
            createdAt
            createdByUserId
            domain
            id
            members {
              nextToken
              __typename
            }
            name
            planKey
            planPriceId
            resources {
              nextToken
              __typename
            }
            seatLimit
            stripeCustomerId
            stripeSubscriptionId
            subscriptionStatus
            updatedAt
            __typename
          }
          companyId
          createdAt
          email
          id
          role
          status
          updatedAt
          userId
          __typename
        }
        nextToken
        __typename
      }
      name
      planKey
      planPriceId
      resources {
        items {
          company {
            billingCycle
            createdAt
            createdByUserId
            domain
            id
            members {
              nextToken
              __typename
            }
            name
            planKey
            planPriceId
            resources {
              nextToken
              __typename
            }
            seatLimit
            stripeCustomerId
            stripeSubscriptionId
            subscriptionStatus
            updatedAt
            __typename
          }
          companyId
          createdAt
          createdByUserId
          description
          id
          name
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      seatLimit
      stripeCustomerId
      stripeSubscriptionId
      subscriptionStatus
      updatedAt
      __typename
    }
  }
`;
export const deleteCompanyMember = /* GraphQL */ `
  mutation DeleteCompanyMember($input: DeleteCompanyMemberInput!) {
    deleteCompanyMember(input: $input) {
      company {
        billingCycle
        createdAt
        createdByUserId
        domain
        id
        members {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            email
            id
            role
            status
            updatedAt
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        planKey
        planPriceId
        resources {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            createdByUserId
            description
            id
            name
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        seatLimit
        stripeCustomerId
        stripeSubscriptionId
        subscriptionStatus
        updatedAt
        __typename
      }
      companyId
      createdAt
      email
      id
      role
      status
      updatedAt
      userId
      __typename
    }
  }
`;
export const deleteCompanyResource = /* GraphQL */ `
  mutation DeleteCompanyResource(
    $condition: ModelCompanyResourceConditionInput
    $input: DeleteCompanyResourceInput!
  ) {
    deleteCompanyResource(condition: $condition, input: $input) {
      company {
        billingCycle
        createdAt
        createdByUserId
        domain
        id
        members {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            email
            id
            role
            status
            updatedAt
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        planKey
        planPriceId
        resources {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            createdByUserId
            description
            id
            name
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        seatLimit
        stripeCustomerId
        stripeSubscriptionId
        subscriptionStatus
        updatedAt
        __typename
      }
      companyId
      createdAt
      createdByUserId
      description
      id
      name
      type
      updatedAt
      url
      __typename
    }
  }
`;
export const deleteComplianceCheck = /* GraphQL */ `
  mutation DeleteComplianceCheck(
    $condition: ModelComplianceCheckConditionInput
    $input: DeleteComplianceCheckInput!
  ) {
    deleteComplianceCheck(condition: $condition, input: $input) {
      createdAt
      estimatedCompletion
      id
      jobId
      processedDocuments
      projectId
      prompt
      selectedRequirementId
      status
      totalDocuments
      updatedAt
      userId
      __typename
    }
  }
`;
export const deleteComplianceIssue = /* GraphQL */ `
  mutation DeleteComplianceIssue(
    $condition: ModelComplianceIssueConditionInput
    $input: DeleteComplianceIssueInput!
  ) {
    deleteComplianceIssue(condition: $condition, input: $input) {
      aiAnalysis
      assignedTo
      categories
      checkId
      confidence
      createdAt
      deadline
      description
      expectedCompliance
      id
      identifiedIssue
      ncCode
      projectId
      references
      severity
      sourceDocuments
      status
      tags
      updatedAt
      __typename
    }
  }
`;
export const deleteParameter = /* GraphQL */ `
  mutation DeleteParameter(
    $condition: ModelParameterConditionInput
    $input: DeleteParameterInput!
  ) {
    deleteParameter(condition: $condition, input: $input) {
      createdAt
      id
      name
      operator
      requirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        storageLinkId
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        subRequirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        title
        updatedAt
        __typename
      }
      requirementId
      subRequirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        requirement {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          storageLinkId
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          subRequirements {
            items {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          title
          updatedAt
          __typename
        }
        requirementId
        title
        updatedAt
        __typename
      }
      subRequirementId
      type
      unit
      updatedAt
      value
      __typename
    }
  }
`;
export const deleteProject = /* GraphQL */ `
  mutation DeleteProject(
    $condition: ModelProjectConditionInput
    $input: DeleteProjectInput!
  ) {
    deleteProject(condition: $condition, input: $input) {
      adjacentStreets
      averageGrade
      buildingClassification
      buildingFootprintArea
      buildingHeight
      buildingFootprintAreaExisting
      buildingFootprintAreaProposed
      grossFloorAreaExisting
      grossFloorAreaProposed
      communicationLinks {
        items {
          createdAt
          id
          name
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      companyId
      constructionType
      createdAt
      description
      entitiesData
      estimatedCompletion
      fireAlarm
      grossFloorArea
      hasBuildingCodeExtractions
      hazardousSubstances
      highBuilding
      id
      lastModified
      location
      majorOccupancy
      members {
        items {
          createdAt
          id
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          role
          updatedAt
          user {
            createdAt
            email
            id
            membershipId
            memberships {
              nextToken
              __typename
            }
            name
            updatedAt
            __typename
          }
          userId
          __typename
        }
        nextToken
        __typename
      }
      name
      occupancyCodes
      occupancyRegion
      occupancyTypes
      owner
      phase
      projectCategory
      requirements {
        items {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          storageLinkId
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          subRequirements {
            items {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          title
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      roughConstructionBudget
      settings {
        autoSave
        createdAt
        id
        notifications
        owner
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        theme
        updatedAt
        __typename
      }
      siteArea
      sprinklerSystem
      standpipe
      startDate
      status
      storageLinks {
        items {
          createdAt
          id
          name
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      storeysAboveGrade
      storeysBelowGrade
      team {
        createdAt
        id
        name
        projects {
          items {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      teamId
      type
      updatedAt
      zoningDesignation
      __typename
    }
  }
`;
export const deleteProjectMember = /* GraphQL */ `
  mutation DeleteProjectMember(
    $condition: ModelProjectMemberConditionInput
    $input: DeleteProjectMemberInput!
  ) {
    deleteProjectMember(condition: $condition, input: $input) {
      createdAt
      id
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      role
      updatedAt
      user {
        createdAt
        email
        id
        membershipId
        memberships {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        updatedAt
        __typename
      }
      userId
      __typename
    }
  }
`;
export const deleteProjectSettings = /* GraphQL */ `
  mutation DeleteProjectSettings(
    $condition: ModelProjectSettingsConditionInput
    $input: DeleteProjectSettingsInput!
  ) {
    deleteProjectSettings(condition: $condition, input: $input) {
      autoSave
      createdAt
      id
      notifications
      owner
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      theme
      updatedAt
      __typename
    }
  }
`;
export const deleteRequirement = /* GraphQL */ `
  mutation DeleteRequirement(
    $condition: ModelRequirementConditionInput
    $input: DeleteRequirementInput!
  ) {
    deleteRequirement(condition: $condition, input: $input) {
      createdAt
      description
      id
      parameters {
        items {
          createdAt
          id
          name
          operator
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          subRequirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          subRequirementId
          type
          unit
          updatedAt
          value
          __typename
        }
        nextToken
        __typename
      }
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      storageLinkId
      storageLinks {
        items {
          createdAt
          id
          name
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      subRequirements {
        items {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          title
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      title
      updatedAt
      __typename
    }
  }
`;
export const deleteStorageLink = /* GraphQL */ `
  mutation DeleteStorageLink(
    $condition: ModelStorageLinkConditionInput
    $input: DeleteStorageLinkInput!
  ) {
    deleteStorageLink(condition: $condition, input: $input) {
      createdAt
      id
      name
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      requirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        storageLinkId
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        subRequirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        title
        updatedAt
        __typename
      }
      requirementId
      type
      updatedAt
      url
      __typename
    }
  }
`;
export const deleteSubRequirement = /* GraphQL */ `
  mutation DeleteSubRequirement(
    $condition: ModelSubRequirementConditionInput
    $input: DeleteSubRequirementInput!
  ) {
    deleteSubRequirement(condition: $condition, input: $input) {
      createdAt
      description
      id
      parameters {
        items {
          createdAt
          id
          name
          operator
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          subRequirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          subRequirementId
          type
          unit
          updatedAt
          value
          __typename
        }
        nextToken
        __typename
      }
      requirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        storageLinkId
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        subRequirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        title
        updatedAt
        __typename
      }
      requirementId
      title
      updatedAt
      __typename
    }
  }
`;
export const deleteTeam = /* GraphQL */ `
  mutation DeleteTeam(
    $condition: ModelTeamConditionInput
    $input: DeleteTeamInput!
  ) {
    deleteTeam(condition: $condition, input: $input) {
      createdAt
      id
      name
      projects {
        items {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $condition: ModelUserConditionInput
    $input: DeleteUserInput!
  ) {
    deleteUser(condition: $condition, input: $input) {
      createdAt
      email
      id
      membershipId
      memberships {
        items {
          createdAt
          id
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          role
          updatedAt
          user {
            createdAt
            email
            id
            membershipId
            memberships {
              nextToken
              __typename
            }
            name
            updatedAt
            __typename
          }
          userId
          __typename
        }
        nextToken
        __typename
      }
      name
      updatedAt
      __typename
    }
  }
`;
export const updateCommunicationLink = /* GraphQL */ `
  mutation UpdateCommunicationLink(
    $condition: ModelCommunicationLinkConditionInput
    $input: UpdateCommunicationLinkInput!
  ) {
    updateCommunicationLink(condition: $condition, input: $input) {
      createdAt
      id
      name
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      type
      updatedAt
      url
      __typename
    }
  }
`;
export const updateCompany = /* GraphQL */ `
  mutation UpdateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      billingCycle
      createdAt
      createdByUserId
      domain
      id
      members {
        items {
          company {
            billingCycle
            createdAt
            createdByUserId
            domain
            id
            members {
              nextToken
              __typename
            }
            name
            planKey
            planPriceId
            resources {
              nextToken
              __typename
            }
            seatLimit
            stripeCustomerId
            stripeSubscriptionId
            subscriptionStatus
            updatedAt
            __typename
          }
          companyId
          createdAt
          email
          id
          role
          status
          updatedAt
          userId
          __typename
        }
        nextToken
        __typename
      }
      name
      planKey
      planPriceId
      resources {
        items {
          company {
            billingCycle
            createdAt
            createdByUserId
            domain
            id
            members {
              nextToken
              __typename
            }
            name
            planKey
            planPriceId
            resources {
              nextToken
              __typename
            }
            seatLimit
            stripeCustomerId
            stripeSubscriptionId
            subscriptionStatus
            updatedAt
            __typename
          }
          companyId
          createdAt
          createdByUserId
          description
          id
          name
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      seatLimit
      stripeCustomerId
      stripeSubscriptionId
      subscriptionStatus
      updatedAt
      __typename
    }
  }
`;
export const updateCompanyMember = /* GraphQL */ `
  mutation UpdateCompanyMember($input: UpdateCompanyMemberInput!) {
    updateCompanyMember(input: $input) {
      company {
        billingCycle
        createdAt
        createdByUserId
        domain
        id
        members {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            email
            id
            role
            status
            updatedAt
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        planKey
        planPriceId
        resources {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            createdByUserId
            description
            id
            name
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        seatLimit
        stripeCustomerId
        stripeSubscriptionId
        subscriptionStatus
        updatedAt
        __typename
      }
      companyId
      createdAt
      email
      id
      role
      status
      updatedAt
      userId
      __typename
    }
  }
`;
export const updateCompanyResource = /* GraphQL */ `
  mutation UpdateCompanyResource(
    $condition: ModelCompanyResourceConditionInput
    $input: UpdateCompanyResourceInput!
  ) {
    updateCompanyResource(condition: $condition, input: $input) {
      company {
        billingCycle
        createdAt
        createdByUserId
        domain
        id
        members {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            email
            id
            role
            status
            updatedAt
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        planKey
        planPriceId
        resources {
          items {
            company {
              billingCycle
              createdAt
              createdByUserId
              domain
              id
              name
              planKey
              planPriceId
              seatLimit
              stripeCustomerId
              stripeSubscriptionId
              subscriptionStatus
              updatedAt
              __typename
            }
            companyId
            createdAt
            createdByUserId
            description
            id
            name
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        seatLimit
        stripeCustomerId
        stripeSubscriptionId
        subscriptionStatus
        updatedAt
        __typename
      }
      companyId
      createdAt
      createdByUserId
      description
      id
      name
      type
      updatedAt
      url
      __typename
    }
  }
`;
export const updateComplianceCheck = /* GraphQL */ `
  mutation UpdateComplianceCheck(
    $condition: ModelComplianceCheckConditionInput
    $input: UpdateComplianceCheckInput!
  ) {
    updateComplianceCheck(condition: $condition, input: $input) {
      createdAt
      estimatedCompletion
      id
      jobId
      processedDocuments
      projectId
      prompt
      selectedRequirementId
      status
      totalDocuments
      updatedAt
      userId
      __typename
    }
  }
`;
export const updateComplianceIssue = /* GraphQL */ `
  mutation UpdateComplianceIssue(
    $condition: ModelComplianceIssueConditionInput
    $input: UpdateComplianceIssueInput!
  ) {
    updateComplianceIssue(condition: $condition, input: $input) {
      aiAnalysis
      assignedTo
      categories
      checkId
      confidence
      createdAt
      deadline
      description
      expectedCompliance
      id
      identifiedIssue
      ncCode
      projectId
      references
      severity
      sourceDocuments
      status
      tags
      updatedAt
      __typename
    }
  }
`;
export const updateParameter = /* GraphQL */ `
  mutation UpdateParameter(
    $condition: ModelParameterConditionInput
    $input: UpdateParameterInput!
  ) {
    updateParameter(condition: $condition, input: $input) {
      createdAt
      id
      name
      operator
      requirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        storageLinkId
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        subRequirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        title
        updatedAt
        __typename
      }
      requirementId
      subRequirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        requirement {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          storageLinkId
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          subRequirements {
            items {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          title
          updatedAt
          __typename
        }
        requirementId
        title
        updatedAt
        __typename
      }
      subRequirementId
      type
      unit
      updatedAt
      value
      __typename
    }
  }
`;
export const updateProject = /* GraphQL */ `
  mutation UpdateProject(
    $condition: ModelProjectConditionInput
    $input: UpdateProjectInput!
  ) {
    updateProject(condition: $condition, input: $input) {
      adjacentStreets
      averageGrade
      buildingClassification
      buildingFootprintArea
      buildingHeight
      buildingFootprintAreaExisting
      buildingFootprintAreaProposed
      grossFloorAreaExisting
      grossFloorAreaProposed
      communicationLinks {
        items {
          createdAt
          id
          name
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      companyId
      constructionType
      createdAt
      description
      entitiesData
      estimatedCompletion
      fireAlarm
      grossFloorArea
      hasBuildingCodeExtractions
      hazardousSubstances
      highBuilding
      id
      lastModified
      location
      majorOccupancy
      members {
        items {
          createdAt
          id
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          role
          updatedAt
          user {
            createdAt
            email
            id
            membershipId
            memberships {
              nextToken
              __typename
            }
            name
            updatedAt
            __typename
          }
          userId
          __typename
        }
        nextToken
        __typename
      }
      name
      occupancyCodes
      occupancyRegion
      occupancyTypes
      owner
      phase
      projectCategory
      requirements {
        items {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          storageLinkId
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          subRequirements {
            items {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          title
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      roughConstructionBudget
      settings {
        autoSave
        createdAt
        id
        notifications
        owner
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        theme
        updatedAt
        __typename
      }
      siteArea
      sprinklerSystem
      standpipe
      startDate
      status
      storageLinks {
        items {
          createdAt
          id
          name
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      storeysAboveGrade
      storeysBelowGrade
      team {
        createdAt
        id
        name
        projects {
          items {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      teamId
      type
      updatedAt
      zoningDesignation
      __typename
    }
  }
`;
export const updateProjectMember = /* GraphQL */ `
  mutation UpdateProjectMember(
    $condition: ModelProjectMemberConditionInput
    $input: UpdateProjectMemberInput!
  ) {
    updateProjectMember(condition: $condition, input: $input) {
      createdAt
      id
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      role
      updatedAt
      user {
        createdAt
        email
        id
        membershipId
        memberships {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        updatedAt
        __typename
      }
      userId
      __typename
    }
  }
`;
export const updateProjectSettings = /* GraphQL */ `
  mutation UpdateProjectSettings(
    $condition: ModelProjectSettingsConditionInput
    $input: UpdateProjectSettingsInput!
  ) {
    updateProjectSettings(condition: $condition, input: $input) {
      autoSave
      createdAt
      id
      notifications
      owner
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      theme
      updatedAt
      __typename
    }
  }
`;
export const updateRequirement = /* GraphQL */ `
  mutation UpdateRequirement(
    $condition: ModelRequirementConditionInput
    $input: UpdateRequirementInput!
  ) {
    updateRequirement(condition: $condition, input: $input) {
      createdAt
      description
      id
      parameters {
        items {
          createdAt
          id
          name
          operator
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          subRequirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          subRequirementId
          type
          unit
          updatedAt
          value
          __typename
        }
        nextToken
        __typename
      }
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      storageLinkId
      storageLinks {
        items {
          createdAt
          id
          name
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          type
          updatedAt
          url
          __typename
        }
        nextToken
        __typename
      }
      subRequirements {
        items {
          createdAt
          description
          id
          parameters {
            items {
              createdAt
              id
              name
              operator
              requirementId
              subRequirementId
              type
              unit
              updatedAt
              value
              __typename
            }
            nextToken
            __typename
          }
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          title
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      title
      updatedAt
      __typename
    }
  }
`;
export const updateStorageLink = /* GraphQL */ `
  mutation UpdateStorageLink(
    $condition: ModelStorageLinkConditionInput
    $input: UpdateStorageLinkInput!
  ) {
    updateStorageLink(condition: $condition, input: $input) {
      createdAt
      id
      name
      project {
        adjacentStreets
        averageGrade
        buildingClassification
        buildingFootprintArea
        buildingHeight
        buildingFootprintAreaExisting
        buildingFootprintAreaProposed
        grossFloorAreaExisting
        grossFloorAreaProposed
        communicationLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        companyId
        constructionType
        createdAt
        description
        entitiesData
        estimatedCompletion
        fireAlarm
        grossFloorArea
        hasBuildingCodeExtractions
        hazardousSubstances
        highBuilding
        id
        lastModified
        location
        majorOccupancy
        members {
          items {
            createdAt
            id
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            role
            updatedAt
            user {
              createdAt
              email
              id
              membershipId
              name
              updatedAt
              __typename
            }
            userId
            __typename
          }
          nextToken
          __typename
        }
        name
        occupancyCodes
        occupancyRegion
        occupancyTypes
        owner
        phase
        projectCategory
        requirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        roughConstructionBudget
        settings {
          autoSave
          createdAt
          id
          notifications
          owner
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          theme
          updatedAt
          __typename
        }
        siteArea
        sprinklerSystem
        standpipe
        startDate
        status
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        storeysAboveGrade
        storeysBelowGrade
        team {
          createdAt
          id
          name
          projects {
            items {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        teamId
        type
        updatedAt
        zoningDesignation
        __typename
      }
      projectId
      requirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        storageLinkId
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        subRequirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        title
        updatedAt
        __typename
      }
      requirementId
      type
      updatedAt
      url
      __typename
    }
  }
`;
export const updateSubRequirement = /* GraphQL */ `
  mutation UpdateSubRequirement(
    $condition: ModelSubRequirementConditionInput
    $input: UpdateSubRequirementInput!
  ) {
    updateSubRequirement(condition: $condition, input: $input) {
      createdAt
      description
      id
      parameters {
        items {
          createdAt
          id
          name
          operator
          requirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            storageLinkId
            storageLinks {
              nextToken
              __typename
            }
            subRequirements {
              nextToken
              __typename
            }
            title
            updatedAt
            __typename
          }
          requirementId
          subRequirement {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          subRequirementId
          type
          unit
          updatedAt
          value
          __typename
        }
        nextToken
        __typename
      }
      requirement {
        createdAt
        description
        id
        parameters {
          items {
            createdAt
            id
            name
            operator
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            subRequirement {
              createdAt
              description
              id
              requirementId
              title
              updatedAt
              __typename
            }
            subRequirementId
            type
            unit
            updatedAt
            value
            __typename
          }
          nextToken
          __typename
        }
        project {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        projectId
        storageLinkId
        storageLinks {
          items {
            createdAt
            id
            name
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            type
            updatedAt
            url
            __typename
          }
          nextToken
          __typename
        }
        subRequirements {
          items {
            createdAt
            description
            id
            parameters {
              nextToken
              __typename
            }
            requirement {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            requirementId
            title
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        title
        updatedAt
        __typename
      }
      requirementId
      title
      updatedAt
      __typename
    }
  }
`;
export const updateTeam = /* GraphQL */ `
  mutation UpdateTeam(
    $condition: ModelTeamConditionInput
    $input: UpdateTeamInput!
  ) {
    updateTeam(condition: $condition, input: $input) {
      createdAt
      id
      name
      projects {
        items {
          adjacentStreets
          averageGrade
          buildingClassification
          buildingFootprintArea
          buildingHeight
          buildingFootprintAreaExisting
          buildingFootprintAreaProposed
          grossFloorAreaExisting
          grossFloorAreaProposed
          communicationLinks {
            items {
              createdAt
              id
              name
              projectId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          companyId
          constructionType
          createdAt
          description
          entitiesData
          estimatedCompletion
          fireAlarm
          grossFloorArea
          hasBuildingCodeExtractions
          hazardousSubstances
          highBuilding
          id
          lastModified
          location
          majorOccupancy
          members {
            items {
              createdAt
              id
              projectId
              role
              updatedAt
              userId
              __typename
            }
            nextToken
            __typename
          }
          name
          occupancyCodes
          occupancyRegion
          occupancyTypes
          owner
          phase
          projectCategory
          requirements {
            items {
              createdAt
              description
              id
              projectId
              storageLinkId
              title
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          roughConstructionBudget
          settings {
            autoSave
            createdAt
            id
            notifications
            owner
            project {
              adjacentStreets
              averageGrade
              buildingClassification
              buildingFootprintArea
              buildingHeight
              buildingFootprintAreaExisting
              buildingFootprintAreaProposed
              grossFloorAreaExisting
              grossFloorAreaProposed
              companyId
              constructionType
              createdAt
              description
              entitiesData
              estimatedCompletion
              fireAlarm
              grossFloorArea
              hasBuildingCodeExtractions
              hazardousSubstances
              highBuilding
              id
              lastModified
              location
              majorOccupancy
              name
              occupancyCodes
              occupancyRegion
              occupancyTypes
              owner
              phase
              projectCategory
              roughConstructionBudget
              siteArea
              sprinklerSystem
              standpipe
              startDate
              status
              storeysAboveGrade
              storeysBelowGrade
              teamId
              type
              updatedAt
              zoningDesignation
              __typename
            }
            projectId
            theme
            updatedAt
            __typename
          }
          siteArea
          sprinklerSystem
          standpipe
          startDate
          status
          storageLinks {
            items {
              createdAt
              id
              name
              projectId
              requirementId
              type
              updatedAt
              url
              __typename
            }
            nextToken
            __typename
          }
          storeysAboveGrade
          storeysBelowGrade
          team {
            createdAt
            id
            name
            projects {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          teamId
          type
          updatedAt
          zoningDesignation
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $condition: ModelUserConditionInput
    $input: UpdateUserInput!
  ) {
    updateUser(condition: $condition, input: $input) {
      createdAt
      email
      id
      membershipId
      memberships {
        items {
          createdAt
          id
          project {
            adjacentStreets
            averageGrade
            buildingClassification
            buildingFootprintArea
            buildingHeight
            buildingFootprintAreaExisting
            buildingFootprintAreaProposed
            grossFloorAreaExisting
            grossFloorAreaProposed
            communicationLinks {
              nextToken
              __typename
            }
            companyId
            constructionType
            createdAt
            description
            entitiesData
            estimatedCompletion
            fireAlarm
            grossFloorArea
            hasBuildingCodeExtractions
            hazardousSubstances
            highBuilding
            id
            lastModified
            location
            majorOccupancy
            members {
              nextToken
              __typename
            }
            name
            occupancyCodes
            occupancyRegion
            occupancyTypes
            owner
            phase
            projectCategory
            requirements {
              nextToken
              __typename
            }
            roughConstructionBudget
            settings {
              autoSave
              createdAt
              id
              notifications
              owner
              projectId
              theme
              updatedAt
              __typename
            }
            siteArea
            sprinklerSystem
            standpipe
            startDate
            status
            storageLinks {
              nextToken
              __typename
            }
            storeysAboveGrade
            storeysBelowGrade
            team {
              createdAt
              id
              name
              updatedAt
              __typename
            }
            teamId
            type
            updatedAt
            zoningDesignation
            __typename
          }
          projectId
          role
          updatedAt
          user {
            createdAt
            email
            id
            membershipId
            memberships {
              nextToken
              __typename
            }
            name
            updatedAt
            __typename
          }
          userId
          __typename
        }
        nextToken
        __typename
      }
      name
      updatedAt
      __typename
    }
  }
`;
